import { useEffect, useState } from 'react';
import { promptPwaInstall, subscribeToPwaInstall } from '@/utils/pwaInstall';

export const usePwaInstall = () => {
  const [canInstall, setCanInstall] = useState(false);

  useEffect(() => {
    return subscribeToPwaInstall(setCanInstall);
  }, []);

  return { canInstall, promptInstall: promptPwaInstall };
};
